export default "__VITE_ASSET__26698bee__"